<template>
  <ul
    class="nav"
  >
    <li
      v-for="tabItem in tabs"
      :key="tabItem"
    >
      <a
        class="nav__item"
        :class="{ 'active': selectTab === tabItem }"
        @click="$emit('selectTab', tabItem)"
      >
        {{ tabItem }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'UiNav',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    selectTab: {
      type: String,
      default: '',
    },
  },
};
</script>
